import { RootState } from "../store";
import { IComposeStore } from "./slice";

// Returning custom object for each select causes additional re-renders as new object fails the equality check
// new objects can still be returned but each use of the selector needs a to use shallowEqual from redux
// returning entire messageCompose store is more fail proof approach
export const selectMessageComposeData = (state: RootState): IComposeStore =>
  state.messageCompose;
